import Scraper from '@/store/models/Scraper'
import { loadScraper, saveScraper, loadScraperList } from '@/api/super'

export default {

  namespaced: true,

  state: {
    scraper: new Scraper(),
    scraperList: []
  },

  mutations: {
    ...Scraper.mutations(),
    setScraperList: (state, payload) => state.scraperList = payload
  },

  actions: {
    loadScraper: ({commit}, scraperId) => new Promise((resolve, reject) => {
      loadScraper(scraperId, ({data}) => {
        commit('setScraper', data)
        resolve()
      }, reject)
    }),
    save: ({ state }) => new Promise((resolve, reject) => saveScraper(state.scraper, resolve, reject)),
    loadScraperList: ({ commit }) => new Promise((resolve, reject) => {
      loadScraperList(({data}) => {
        commit('setScraperList', data)
        resolve()
      }, reject)
    }),
  },

  getters: {
    scraper: state => state.scraper,
    scraperList: state => state.scraperList,
  }

}